<script setup lang="ts">
// « Votre formule » dans la colonne verte : garanties incluses cochées d'office,
// entretien et pièces d'usure à cocher (sur demande, sans effet sur la mensualité).
defineProps<{
    premiumWarranty: boolean;
    purchaseValueWarranty: boolean;
}>();

const maintenanceRequested = defineModel<boolean>("maintenanceRequested", {
    default: false,
});
</script>

<template>
    <div class="formula" data-testid="simulation-formula">
        <p class="formula__title">Votre formule</p>
        <ul class="formula__list">
            <li v-if="premiumWarranty">
                <span class="formula__box formula__box--included">
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                    >
                        <path d="M5 12l5 5 9-10" />
                    </svg>
                </span>
                <span>Garantie premium étendue</span>
                <span class="formula__tag formula__tag--included">Incluse</span>
            </li>
            <li v-if="purchaseValueWarranty">
                <span class="formula__box formula__box--included">
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                    >
                        <path d="M5 12l5 5 9-10" />
                    </svg>
                </span>
                <span>Garantie valeur d'achat</span>
                <span class="formula__tag formula__tag--included">Incluse</span>
            </li>
            <li class="formula__optional">
                <label class="formula__option">
                    <input
                        v-model="maintenanceRequested"
                        type="checkbox"
                        class="formula__input"
                        data-testid="maintenance-requested"
                    />
                    <span class="formula__box" aria-hidden="true">
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="3.4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path d="M5 12l5 5 9-10" />
                        </svg>
                    </span>
                    <span>Entretien et pièces d'usure</span>
                    <span class="formula__tag">Sur demande</span>
                </label>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
.formula {
    margin-top: 1.25rem;
    padding-top: 1.25rem;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    color: white;

    &__title {
        margin: 0 0 0.75rem;
        font-family: $bebas;
        font-size: 1.125rem;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
    }

    &__list {
        display: grid;
        gap: 0.5rem;
        margin: 0;
        padding: 0;
        list-style: none;

        li:not(.formula__optional),
        .formula__option {
            display: grid;
            grid-template-columns: 22px 1fr auto;
            gap: 0.75rem;
            align-items: center;
            font-size: 0.9375rem;
        }
    }

    &__option {
        position: relative;
        cursor: pointer;
    }

    &__input {
        position: absolute;
        opacity: 0;
        width: 1px;
        height: 1px;
    }

    &__box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 5px;
        border: 1.5px solid rgba(255, 255, 255, 0.75);
        color: transparent;

        &--included {
            border-color: $primary;
            background: $primary;
            color: $dark-font;
        }
    }

    &__input:checked + &__box {
        border-color: $primary;
        background: $primary;
        color: $dark-font;
    }

    &__input:focus-visible + &__box {
        outline: 2px solid $primary;
        outline-offset: 2px;
    }

    &__tag {
        font-size: 0.75rem;
        white-space: nowrap;
        color: rgba(255, 255, 255, 0.65);

        &--included {
            color: $primary;
        }
    }

    // Ordinateur peu haut : la liste tient avec la calculette sans faire défiler la colonne
    @media (min-width: 1024px) and (max-height: 900px) {
        margin-top: 1rem;
        padding-top: 1rem;

        &__title {
            margin-bottom: 0.625rem;
        }

        &__list {
            gap: 0.375rem;
        }
    }
}
</style>
